import Loadable from 'react-loadable'
import Loading from '@/sc_components/Loading'

// 懒加载页面
const asyncLoad = (loader) => Loadable({
	loader: loader,
	loading: Loading,
	delay: 200, // 加载时间超过delay毫秒时，转菊花
	timeout: 5000, // 加载超时时间：5秒
})

// 路由配置
const routeConfig = [
	// 在此处添加页面路由
	{
		path: '/',
		component: asyncLoad(() => import('./page/home-page/index' /* webpackChunkName:'home-page' */))
	},
	// 没有匹配任何路由，绘制 404 PageNotFound 页面
	{
		component: asyncLoad(() => import('@/sc_components/PageNotFound' /* webpackChunkName:'page-not-found' */))
	}
]

export {routeConfig}
